import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { FC, PropsWithChildren, useEffect, useRef, useState } from "react";
export interface SwiperProps {
  className?: string;
}
const SwiperSlide: FC<PropsWithChildren> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="swiper-slide select-none first:snap-start snap-center first:pl-s last:pr-s px-2xs">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const Swiper: FC<PropsWithChildren<SwiperProps>> = t0 => {
  const $ = _c(13);
  const {
    children,
    className
  } = t0;
  const ref = useRef(null);
  const [height, setHeight] = useState();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setHeight(ref.current ? ref.current?.clientHeight - 32 : undefined);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = clsx("overflow-hidden w-full flex grow");
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== height) {
    t4 = {
      height
    };
    $[3] = height;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children) {
    t5 = <div className="overflow-x-auto grow flex w-full snap-mandatory snap-x pb-m h-full box-content" ref={ref}>{children}</div>;
    $[5] = children;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div className={t3} style={t4}>{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== className || $[11] !== t6) {
    t7 = <div className={className}>{t6}</div>;
    $[10] = className;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
export default Object.assign(Swiper, {
  Slide: SwiperSlide
});